import { configureStore } from "@reduxjs/toolkit";
import departmentSlice from "./modules/department/departmentSlice";
import patientProfileSlice from "./modules/patientProfile/patientProfileSlice";
import loadingSlice from "./modules/loading/loadingSlice";
import scrollReducer from "./modules/scrollToTop/scrollToTop.js";
import statusSlice from "./modules/status/status.js";
import verifyType from "./modules/status/verificationType.js";
import user from "./modules/status/user";
import article from "./modules/article/ArticleSlice.js";
import NationalIdSlice from "./modules/NationalIdCategory/NationalIdSlice.js";
import notification from "./modules/notification/notificationSlice.js";
import tnc from "./modules/TNC/tncSlice.js";
import addConsumable from "./modules/NursignCare/AdditonalConsumable/AddConsumableSlice.js";
import manageNurse from "./modules/NursignCare/ManageNurse/ManageNurseSlice.js";
import manageService from "./modules/NursignCare/ManageServices/ManageServiceSlice.js";
import transportationFeeReducer from "./modules/NursignCare/TransportationFee/transportationFeeSlice.js";
import languageReducer from "./modules/language/languageSlice.js";
import manageRequestReducer from "./modules/NursignCare/ManageRequest/manageRequestSlice.js";
import chatReducer from "./modules/Chat/chatSlice.js";

const logger = (store) => (next) => (action) => {
  return next(action);
};

export const Store = configureStore({
  reducer: {
    department: departmentSlice,
    patientProfile: patientProfileSlice,
    loading: loadingSlice,
    scroll: scrollReducer,
    status: statusSlice,
    verifyType: verifyType,
    user: user,
    article: article,
    nationalId: NationalIdSlice,
    notification: notification,
    tnc: tnc,
    addConsumable,
    manageNurse,
    manageService,
    transportationFee: transportationFeeReducer,
    language: languageReducer,
    manageRequest: manageRequestReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});
